package one.devsbox.shared.files

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.SerializersModuleBuilder
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass
import one.devsbox.commons.JSON_INSTANCE

object SharedIO {

    val JSON_INSTANCE_FILES = Json(JSON_INSTANCE) {
        serializersModule = SerializersModule {
            with(FileInfo) {
                serializerModule()
            }
        }
    }


    @Serializable
    sealed interface FileInfo {
        var id: Long
        var width: Int
        var height: Int
        var size: Long
        var name: String
        val aspectRatio: String
        var colors: String
        var tags: String
        var description: String

        companion object {
            fun SerializersModuleBuilder.serializerModule() {
                polymorphic(FileInfo::class) {
                    subclass(Image::class)
                    subclass(Video::class)
                    subclass(Pdf::class)
                }
            }
        }

        @Serializable
        data class Image(
            override var id: Long,
            override var width: Int,
            override var height: Int,
            override var size: Long,
            override var name: String,
            override val aspectRatio: String,
            override var colors: String,
            override var tags: String,
            override var description: String,
        ) : FileInfo {
            companion object {}
        }

        @Serializable
        data class Video(
            override var id: Long,
            override var width: Int,
            override var height: Int,
            override var size: Long,
            override var name: String,
            override val aspectRatio: String,
            override var colors: String,
            override var tags: String,
            override var description: String,
            var duration: Long,
        ) : FileInfo {
            companion object {}
        }

        @Serializable
        data class Pdf(
            override var id: Long,
            override var width: Int,
            override var height: Int,
            override var size: Long,
            override var name: String,
            override val aspectRatio: String,
            var pages: Int,
            override var colors: String = "",
            override var tags: String,
            override var description: String,
        ) : FileInfo {
            companion object {}
        }
    }

    @Serializable
    data class VisualPropertiesIn(
        var name: String = "",
        var width: Int,
        var height: Int,
        var durationMs: Long = 0,
        /**
         * @see ResourceScale
         */
        var scale: Int = ResourceScale.FILL.mask
    ) {}

    @Serializable
    data class VisualProperties(
        var path: String = "",
        var wd: String = "",

        var widthIn: Int,
        var heightIn: Int,
        var durationMsIn: Long,

        var widthOut: Int = widthIn,
        var heightOut: Int = heightIn,
        var durationMsOut: Long = durationMsIn,
        var sourceType: Int =  ResourceType.VIDEO.mask,
        var animation:String = "",

        /**
         * @see ResourceScale
         */
        var scale: Int = ResourceScale.FILL.mask
    ) {
        companion object {}

        fun normalizedOutput(): Pair<Int, Int> {
            val w = widthOut.takeIf { it % 2 == 0 }
                ?: (widthOut + 1)

            val h = heightOut.takeIf { it % 2 == 0 }
                ?: (heightOut + 1)
            return w to h
        }
    }
}